import React from 'react';
import View from '../../../elements/View';
import { ButtonGroup, ButtonToolbar, Col, Container, Row, Button as RButton } from 'reactstrap';
import theme from '../../../Theme';
import { T } from '../../../helpers/i18n';
import { General } from './Ecommerce/General';
import { inject } from 'mobx-react';
import { loading } from '../../../elements/Loading';
var ModuleEcommerceInner = function (props) {
    var _a = React.useState(EcommerceViews.general), viewSelected = _a[0], setViewSelected = _a[1];
    return (React.createElement(View, { style: { width: '100%' } },
        React.createElement(Container, null,
            React.createElement(Row, null,
                React.createElement(Col, null,
                    React.createElement(ButtonToolbar, null,
                        React.createElement(ButtonGroup, null,
                            React.createElement(RButton, { outline: true, style: {
                                    color: viewSelected === EcommerceViews.general ? theme.color.primary : theme.color.secondary,
                                }, onClick: function () {
                                    setViewSelected(EcommerceViews.general);
                                } }, T('general'))))))),
        React.createElement("div", { style: { display: viewSelected === EcommerceViews.general ? 'block' : 'none' } },
            React.createElement(General, { acount: props.acount })),
        React.createElement("div", { style: { display: viewSelected === EcommerceViews.paymentGateway ? 'block' : 'none' } })));
};
var EcommerceViews = Object.freeze({
    general: 'general',
    paymentGateway: 'paymentGateway',
});
export var ModuleEcommerce = inject('store')(loading(function (props) { return [
    props.store.acountStore
        .read().then(function (acount) {
        console.log('acount: ', acount);
        return { acount: acount };
    })
        .catch(function (error) { return console.log(error); }),
    /*props.store.paymentGawewaysStores.read()
      .then(paymentGateways => ({paymentGateways}))
      .catch(error => console.log('error: ', error))*/
]; })(ModuleEcommerceInner));



//////////////////
// WEBPACK FOOTER
// ./src/modules/Acount/container/ModuleEcommerce.tsx
// module id = 1565
// module chunks = 0